// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"8319f244","2754":"8319f244","3298":"8319f244","3319":"cebb2e9f","5214":"fb6fa01e","5563":"8319f244","8504":"8319f244","8944":"8319f244"}[chunkId] + ".chunk.css";
};